import { API, Endpoints, Lang } from '@brg/api';

type SubmitTeamFormAnswerParams = {
    formId: string;
    formData: any;
    values: Record<string, unknown>;
    language: string;
    isPpdAccepted: boolean;
    teamId: string;
};

export const buildFormAnswerFields = (
    formFields: any[],
    values: Record<string, unknown>,
    language: string,
) => formFields.map((field: any, index: number) => {
    const fieldKey = Object.keys(values).find(
        (key) =>
            key === `field_${field.type}_${index}` ||
            key === field.header[0]?.name?.toLowerCase() ||
            false,
    );

    let response = fieldKey ? values[fieldKey] : '';

    if (field.type === 8 && Array.isArray(response)) {
        response = response.join(', ');
    }

    return {
        type: field.type,
        header: Lang(field.header, language) || '',
        response,
    };
});

export const submitTeamFormAnswer = ({
    formId,
    formData,
    values,
    language,
    isPpdAccepted,
    teamId,
}: SubmitTeamFormAnswerParams) => {
    const formAnswerFields = buildFormAnswerFields(formData.formFields, values, language);

    return API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/forms/AddFormAnswer')
        .post()
        .body({
            formId,
            isShopConnectionForm: true,
            shopTeamId: teamId,
            utmTags: [''],
            pageUrl: `${window.location.host}/teams/${teamId}`,
            formAnswerFields,
            isPpdAccepted,
            Language: language,
        })
        .send();
};
import { API, Endpoints, Lang } from '@brg/api';

type SubmitTeamFormAnswerParams = {
    formId: string;
    formData: any;
    values: Record<string, unknown>;
    language: string;
    isPpdAccepted: boolean;
    teamId: string;
};

export const buildFormAnswerFields = (
    formFields: any[],
    values: Record<string, unknown>,
    language: string,
) => formFields.map((field: any, index: number) => {
    const fieldKey = Object.keys(values).find(
        (key) =>
            key === `field_${field.type}_${index}` ||
            key === field.header[0]?.name?.toLowerCase() ||
            false,
    );

    let response = fieldKey ? values[fieldKey] : '';

    if (field.type === 8 && Array.isArray(response)) {
        response = response.join(', ');
    }

    return {
        type: field.type,
        header: Lang(field.header, language) || '',
        response,
    };
});

export const submitTeamFormAnswer = ({
    formId,
    formData,
    values,
    language,
    isPpdAccepted,
    teamId,
}: SubmitTeamFormAnswerParams) => {
    const formAnswerFields = buildFormAnswerFields(formData.formFields, values, language);

    return API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/forms/AddFormAnswer')
        .post()
        .body({
            formId,
            isShopConnectionForm: true,
            shopTeamId: teamId,
            utmTags: [''],
            pageUrl: `${window.location.host}/teams/${teamId}`,
            formAnswerFields,
            isPpdAccepted,
            Language: language,
        })
        .send();
};
